import { defineMessages } from 'react-intl';

const messages = defineMessages({
  itemName: {
    description: 'advancedSearch.orders.filters.itemName',
    defaultMessage: 'Item Name',
    id: '5RcAmf',
  },
});

export default messages;
